var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-gauge ma-2"},[_c('v-img',{attrs:{"width":"300","src":_vm.ROTOR_COURSE_GAUGE_PLATE}}),_c('v-img',{staticClass:"course-indicator",attrs:{"width":"300","src":_vm.ROTOR_COURSE_GAUGE_INDICATOR}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }